// Airwallex onboarding badges (computed by the API, see BadgeResolver) as the
// Payments list and the connect modal show them.
export const AIRWALLEX_BADGE_LABELS = {
  KYC_NOT_SUBMITTED: "Not submitted",
  KYC_IN_REVIEW: "In review",
  INFORMATION_REQUIRED: "Information required",
  ACTIVE: "Active",
  FROZEN: "Frozen",
  REJECTED: "Rejected",
  DORMANT: "Dormant",
  CLOSED: "Closed",
};

export function airwallexBadgeLabel(badge) {
  return AIRWALLEX_BADGE_LABELS[badge] || badge;
}

export function airwallexBadgeClass(badge) {
  if (badge === "ACTIVE") return "bg-success";
  if (badge === "KYC_IN_REVIEW") return "bg-info";
  if (badge === "INFORMATION_REQUIRED") return "bg-warning";
  if (["FROZEN", "REJECTED"].includes(badge)) return "bg-danger";
  return "bg-secondary";
}
